module.exports = __webpack_public_path__ + "static/media/appStore_badge.a42cc216.svg";